import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import '~/styles/main.scss';

import { SocialCard } from './index';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.SocialCard = SocialCard;
// CLR alias: PortableComponent.cshtml renders SocialCardGallery blocks via this component.
global.SocialCardGallery = SocialCard;
